import { ledgerIdOf } from '@taler/api-client'
import type { QueryKey } from '@tanstack/vue-query'

export function sameLedger(ledgerId: string | undefined) {
  return (key: readonly unknown[]): boolean => {
    const previousLedgerId = ledgerIdOf(key)
    return previousLedgerId !== undefined && previousLedgerId === ledgerId
  }
}

export function sameLedgerAndClass(ledgerId: string | undefined, accountClass: unknown) {
  const sameLedgerAs = sameLedger(ledgerId)
  return (key: readonly unknown[]): boolean => sameLedgerAs(key) && key.at(-1) === accountClass
}

/** Same ledger, and the key carries `value`: one account's or one scenario's query. */
export function sameLedgerAndKeyHolds(ledgerId: string | undefined, value: unknown) {
  const sameLedgerAs = sameLedger(ledgerId)
  return (key: readonly unknown[]): boolean => sameLedgerAs(key) && key.includes(value)
}

/** Keeps the last loaded result while `sameScope` holds for the previous query's key. */
export function keepPreviousListResult(sameScope: (previousKey: QueryKey) => boolean) {
  return <T>(
    previousData: T | undefined,
    previousQuery: { queryKey: QueryKey } | undefined,
  ): T | undefined =>
    previousQuery !== undefined && sameScope(previousQuery.queryKey) ? previousData : undefined
}
